export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Inicializálási hiba",
    "StaticConfigLoader.caption.init": "Inicializálás",
    "StaticConfigLoader.text.init": "Alkalmazás inicializálása...",
    "StaticConfigLoader.error.settings": "Oldalbeállítások betöltése sikertelen",
    "StaticConfigLoader.error.circuits": "Szolgáltatáskonfigurálás betöltése sikertelen",
    //app
    "Legal.Localization": "ht",
    "AchievementApp.Navbar.storeTitle": "Store",
    "AchievementApp.Navbar.supportTitle": "Support",
    "Legal.TermsConditions": "Terms and Conditions",
    "Legal.TermsService": "Terms of Service",
    "Legal.PrivacyPolicy": "Privacy Policy",
    "Legal.CookiesPolicy": "Cookies Settings",
    "Legal.Copyright": "All trademarks, logos and brand names are the property of their respective owners.",
    "AchievementApp.Navbar.achievement": "Személyes teljesítmények",
    "AchievementApp.Navbar.userAchievement": "Felhasználói teljesítmények",
    "AchievementApp.Navbar.settingsLink": "Beállítások",
    "AchievementApp.Navbar.profileLink": "Profil",
    "AchievementApp.Navbar.reloginLink": "Jelentkezzen be újra vagy váltson fiókot",
    "AchievementApp.Navbar.pageTitlePrew": "",
    "AchievementApp.Navbar.pageTitle": "aijin.Net teljesítmények",
    //commonAssets
    "ViewItemDetailed.state.completed": "Teljesítve",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Szűrés címek alapján",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "Barátaim",
    "UserFriendsList.heading.showMore": "Még több mutatása",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "Be kell állítania a kétfaktoros hitelesítést",
    "LimitedAccountPanel.2step.link": "További információk a kétfaktoros hitelesítésről",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "Meg kell erősítenie e-mail-címét",
    "LimitedAccountPanel.email.link": "Továbblépés a profilra",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "Fiókja korlátozott az alábbiak miatt:",
    "LimitedAccountPanel.conclusion": "A biztonsági beállítások megváltoztatása után jelentkezzen ki, majd jelentkezzen be újra, hogy a változtatások életbe lépjenek",
    "LimitedAccountPanel.relogin": "Bejelentkezés újra",
    "EmailVerificationStateIcon.success": "Megerősített fiók, e-mail hitelesítve",
    "EmailVerificationStateIcon.warning": "Nem megerősített fiók, e-mail nincs hitelesítve",
    "EmailVerificationStateIcon.danger": "Nem megerősített fiók, e-mail hitelesítése SZÜKSÉGES",
    "TwoFactorStateIcon.success": "A fiók kétfaktoros hitelesítéssel megerősítve",
    "TwoFactorStateIcon.warning": "Nem biztonságos fiók, kétfaktoros hitelesítés kikapcsolva",
    "TwoFactorStateIcon.danger": "Kétfaktoros hitelesítés SZÜKSÉGES",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Beállítások mentése",
    "UserSettingDialog.settings": "Beállítások",
    "UserSettingDialog.userSettings": "Felhasználói beállítások",
    "UserSettingDialog.language": "Nyelv",
    "UserSettingDialog.privacy": "Adatvédelem",
    "UserSettingDialog.allUsers": "Minden felhasználó",
    "UserSettingDialog.friendsOnly": "Csak barátok",
    "UserSettingDialog.onlyMe": "Csak én",
    "UserSettingDialog.whoCanView": "Ki nézheti meg a teljesítményeimet",
    //unlockProgress
    "ViewUnlockProgress.of": " / ",
    "ViewUnlockProgress.achievCompleted": " teljesítmény elérve",
    "ViewUnlockProgress.myUnlock": "Teljesítményeim",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Becenév keresése itt",
    "ViewItemSearch.label.search": "Felhasználók keresése",
    "ViewItemSearch.resultNotFound": "Felhasználó nem található",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Teljesítmény",
    "ViewItemSearch.stub.empty": "Nincs teljesítmény",
    "ViewItemSearch.stub.emptyCompare_1": "Felhasználó ",
    "ViewItemSearch.stub.emptyCompare_2": " nem ért el teljesítményeket ebben a játékban",
    "ViewItemSearch.limitedAccess": "A kiválasztott felhasználó teljesítményeihez való hozzáférés korlátozott",
    "ViewItemSearch.heading.selectGame": "Játék kiválasztása a listából",
    "ViewItemSearch.globalstat.opened": "feloldotta a játékosok ",
    "ViewItemSearch.globalstat.ofGamers": "%-a",
    //authentication
    "NotAllowedMessage.caption": "Nincs engedélyezve",
    "NotAllowedMessage.body.h1": "A teljesítményhez való hozzáférés",
    "NotAllowedMessage.body.h3": "jelenleg nincs engedélyezve az Ön fiókján",
    "NotAllowedMessage.relogin": "Fiókváltás",
    "LandingMessage.caption": "Hitelesítés",
    "LandingMessage.body": "Töltés befejezése...",
    "TokenExpiredMessage.caption": "Hitelesítés lejárt",
    "TokenExpiredMessage.body.h3": "Nem sokat tehetünk ezzel, de ezt még megteheti:",
    "TokenExpiredMessage.relogin": "Bejelentkezés újra",
    "AuthErrorMessage.caption": "Hitelesítés sikertelen",
    "AuthErrorMessage.body.h1": "A hitelesítés ellenőrzése sikertelen",
    "AuthErrorMessage.body.code": "Kód",
    "AuthErrorMessage.body.desc": "Nem sokat tehetünk ezzel, de ezt még megteheti:",
    "AuthErrorMessage.relogin": "Bejelentkezés újra",
    "AuthorizationRequiredMessage.caption": "Hitelesítés szükséges",
    "AuthorizationRequiredMessage.body.h3.1": "Belépés ebbe:",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "De a továbblépéshez hitelesítésre van szüksége",
    "AuthorizationRequiredMessage.login": "Jelentkezzen be a Gaijin.Nettel",
    "CheckingAuthMessage.caption": "Hitelesítés",
    "CheckingAuthMessage.body": "Hitelesítés ellenőrzése, kérjük, várjon",
    "AuthorizationRequiredMessageMobile.body.h3.1": "A mobil verzió jelenleg nem elérhető",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Kérjük, használja a számítógépes verziót",
    "AuthorizationRequiredMessageMobile.body.h3.3": "Elnézést kérünk",
}